module.exports = __webpack_public_path__ + "img/forestsendai.72a01414.jpg";